import picVideo from './pic&video'
export default {
  components: { picVideo },
  data() {
    return {
      rowData: {},
      picVideoVisible: false
    }
  },
  methods: {
    showDialog(rowData) {
      this.rowData = rowData;
      this.picVideoVisible = true;
    },
    // 显示查看图片、视频按钮
    showDetailBtn(rowData) {
      if (rowData.imgUrl && rowData.imgUrl.length) {
        return true;
      }else{
        return false;
      }
    }
  }
}